export const SET_ZONE_DATA = "SET_ZONE_DATA";
export const SET_STORE_DATA = "SET_STORE_DATA";
export const SET_DASHBOARD_DATA = "SET_DASHBOARD_DATA";
export const SET_DASHBOARD_DATA_FILTER = "SET_DASHBOARD_DATA_FILTER";
export const RESET_ZONE_REDUCER = "RESET_ZONE_REDUCER";
export const SET_ZONE_VIEW_DATA = "SET_ZONE_VIEW_DATA";

